import { History } from "@mui/icons-material";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { useAuditLogContext } from "@ryde/redux";
import { errors, IAuditLogNormalized } from "@ryde/shared";

import { EntityItem } from "./entity-item";

interface IEntitiesListProps {
  entityListData: IAuditLogNormalized[];
}

export const EntitiesList = ({
  entityListData,
}: IEntitiesListProps): ReactNode => {
  const { expandedItems, onToggleExpanded } = useAuditLogContext();
  const { t } = useTranslation();

  if (!entityListData?.length) {
    return (
      <div className="entities-list__empty-state">
        <div className="entities-list__empty-state-message">
          <History className="entities-list__empty-state-icon" />
          {t(errors.auditLog.notFoundAuditLogRecords)}
        </div>
      </div>
    );
  }

  return entityListData.map(entityItemData => (
    <EntityItem
      key={entityItemData.id}
      entityItemData={entityItemData}
      isCollapsed={expandedItems?.has(entityItemData.id) ? true : false}
      onToggleCollapsed={
        onToggleExpanded ? () => onToggleExpanded(entityItemData.id) : undefined
      }
    />
  ));
};
